import { withInstall } from '../../../utils/with-install'
import ThreeTiles3d from './ThreeTiles3d.vue'

export const ElAmapThreeTiles3d = withInstall(ThreeTiles3d)
export default ElAmapThreeTiles3d
